import { initSplideCarousel } from '@/splide-carousel';

/** Tailwind breakpoints (max-width, for Splide's default `mediaQuery: 'max'`). */
const XL_MAX = 1279;
const LG_MAX = 1023;
const SM_MAX = 639;

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-link-row').forEach((block) => {
		initSplideCarousel(block, {
			perPage: 4,
			perMove: 1,
			gap: '2rem',
			trimSpace: 'move',
			breakpoints: {
				[XL_MAX]: {
					perPage: 3,
					gap: '1.25rem',
				},
				[LG_MAX]: {
					perPage: 2,
					gap: '1.25rem',
				},
				[SM_MAX]: {
					// perPage:1 is required even though fixedWidth is set — Splide
					// computes its end index as `slideCount - perPage`, and breakpoint
					// options inherit from larger breakpoints in cascade. Without this
					// override the LG_MAX perPage:2 leaks in and the user can't drag
					// to the final slide.
					perPage: 1,
					fixedWidth: '258px',
					gap: '1.25rem',
					trimSpace: false,
				},
			},
		});
	});
});
